<template>
  <div>
    <p class="cm-mg-p-wzd">
      2.1 {{ $t('fertilization.fertilizers_budgeted_card_info') }}
    </p>
    <hr />
    <br />
    <template>
      <div class="custom-table-responsive table-responsive">
        <table
          class="table table-striped table-bordered table table-journals not-last-td"
        >
          <thead>
            <tr class="cusmtom-thead-color">
              <th
                scope="col"
                rowspan="2"
                class="text-center p-3 custom-header-label"
              >
                {{ $t('fertilization.fertilizer') }}*
              </th>
              <th
                scope="col"
                rowspan="2"
                class="text-center p-3 custom-header-label"
              >
                {{ $t('production.bundle_quantity') }}*
              </th>
              <th
                scope="col"
                rowspan="2"
                class="text-center p-3 custom-header-label"
              >
                {{ $t('production.bundle_quantity_unit') }}*
              </th>
              <th
                scope="col"
                rowspan="2"
                class="text-center p-3 custom-header-label"
              >
                {{ $t('production.bundle_values') }}*
              </th>
              <th
                scope="col"
                rowspan="2"
                class="text-center p-3 custom-header-label"
              >
                {{ $t('production.bundle_quantity') }}*
                <span style="text-transform: lowercase !important">(Ha)</span>
              </th>
              <th
                scope="col"
                rowspan="2"
                class="text-center p-3 custom-header-label"
              >
                {{ $t('production.bundle_values') }}
                <span style="text-transform: lowercase !important">(Ha)</span>
              </th>
              <th
                scope="col"
                rowspan="2"
                class="text-center p-3 custom-header-label"
              >
                {{ $t('common_words.actions') }}
              </th>
              <th
                scope="col"
                :colspan="nutrientsColunm.length"
                style="border-bottom: 1px solid !important"
                class="text-center p-3 custom-header-label"
              >
                {{ $t('samples.nutrient_contribution_unit') }}
              </th>
            </tr>
            <tr class="cusmtom-thead-color">
              <th
                v-for="(column, index) in nutrientsColunm"
                scope="col"
                class="text-center p-3 custom-header-label"
                :key="index"
              >
                {{ column.label }}
              </th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="index_num in fertilizer_len" :key="index_num">
              <td class="text-center" style="min-width: 250px">
                <el-select
                  clearable
                  filterable
                  class="select-primary custom-width-select shadow-sm fer-add required-second-step"
                  size="large"
                  v-model.number="model.fertilizers[index_num - 1]"
                  :placeholder="`${$t('common_words.select')}...`"
                  @change="addFactor(index_num - 1)"
                >
                  <el-option
                    v-for="(option, index) in availableFertilizers"
                    class="select-primary"
                    :value="option.id"
                    :label="option.name"
                    :key="option.id + '' + index"
                  ></el-option>
                </el-select>
              </td>
              <td class="text-center" style="min-width: 150px">
                <el-input
                  clearable
                  class="required-second-step text-center"
                  type="number"
                  min="0"
                  @change="getHectares"
                  v-model="model.packages[index_num - 1]"
                />
              </td>
              <td class="text-center" style="min-width: 150px">
                <template
                  v-if="
                    !isNaN(
                      model.packages[index_num - 1] *
                        fertilizers_factors[index_num - 1]
                    )
                  "
                >
                  {{
                    formatNumber(
                      model.packages[index_num - 1] *
                        fertilizers_factors[index_num - 1]
                    )
                  }}
                </template>
                <template v-else> 0 </template>
              </td>
              <td class="text-center" style="min-width: 180px">
                <el-input
                  clearable
                  class="required-second-step text-center"
                  type="number"
                  min="0"
                  v-model="model.package_values[index_num - 1]"
                />
              </td>
              <td class="text-center" style="min-width: 150px">
                <template
                  v-if="!isNaN(model.packages[index_num - 1] / num_hectares)"
                >
                  {{
                    formatNumber(model.packages[index_num - 1] / num_hectares)
                  }}
                </template>
                <template v-else> 0 </template>
              </td>
              <td class="text-center" style="min-width: 150px">
                <template
                  v-if="
                    !isNaN(
                      (model.packages[index_num - 1] / num_hectares) *
                        model.package_values[index_num - 1]
                    )
                  "
                >
                  {{
                    formatNumber(
                      (model.packages[index_num - 1] / num_hectares) *
                        model.package_values[index_num - 1]
                    )
                  }}
                </template>
                <template v-else> 0 </template>
              </td>
              <td class="text-center" style="min-width: 110px">
                <div class="d-flex justify-content-center mt-3">
                  <a
                    v-if="isUpdate()"
                    v-tooltip.top-center="$t('common_words.edit')"
                    class="btn-warning btn-simple btn-link custom-margin-actions"
                    @click.prevent="fertilizer_len++"
                  >
                    <em class="fa fa-plus custom-size-fa-actions"></em>
                  </a>
                  <a
                    v-if="fertilizer_len > 1"
                    v-tooltip.top-center="$t('common_words.erase')"
                    class="btn-danger btn-simple btn-link custom-margin-actions"
                    @click="handleDelete(index_num - 1)"
                  >
                    <em class="fa fa-times custom-size-fa-actions"></em>
                  </a>
                </div>
              </td>
              <td
                v-for="(column, indexcolumn) in nutrientsColunm"
                class="text-center"
                style="min-width: 100px"
                :key="indexcolumn"
              >
                {{
                  formatNumber(
                    calculateNutrientPercentage(index_num, indexcolumn)
                  )
                }}
              </td>
            </tr>
          </tbody>
          <tfoot>
            <tr>
              <td
                class="text-muted text-center"
                style="font-weight: bold"
                colspan="4"
              >
                Total
              </td>
              <td class="text-muted text-center" style="font-weight: bold">
                {{ formatNumber(calculateTotalPackagesColumn()) }}
              </td>
              <td class="text-muted text-center" style="font-weight: bold">
                {{ formatNumber(calculateTotalValuesColumn()) }}
              </td>
              <td class="text-muted text-center" style="font-weight: bold"></td>
              <td
                v-for="(column, indexcolumn) in nutrientsColunm"
                class="text-muted text-center"
                style="min-width: 100px; font-weight: bold"
                :key="indexcolumn"
              >
                {{
                  formatNumber(calculateTotalPercentagesColumns(indexcolumn))
                }}
              </td>
            </tr>
            <tr v-if="type_budgeted == 'Lote'">
              <td
                class="text-muted text-center"
                style="font-weight: bold"
                colspan="6"
              >
                {{ $t('common_words.recommended') }}
              </td>
              <td class="text-muted text-center" style="font-weight: bold"></td>
              <td
                v-for="(column, indexcolumn) in nutrientsColunm"
                class="text-muted text-center"
                style="min-width: 100px; font-weight: bold"
                :key="indexcolumn"
              >
                {{ recommendations[indexcolumn] }}
              </td>
            </tr>
            <tr v-if="type_budgeted == 'Lote'">
              <td
                class="text-muted text-center"
                style="font-weight: bold"
                colspan="6"
              >
                {{ $t('diseases.diffrence') }}
              </td>
              <td class="text-muted text-center" style="font-weight: bold"></td>
              <td
                v-for="(column, indexcolumn) in nutrientsColunm"
                class="text-muted text-center"
                style="min-width: 100px; font-weight: bold"
                :key="indexcolumn"
              >
                {{ formatNumber(calculateDifference(indexcolumn)) }}
              </td>
            </tr>
          </tfoot>
        </table>
      </div>
      <div class="row" v-show="errorAlert">
        <div class="col-lg-12">
          <br />
          <el-alert
            ref="error_alert"
            :title="$t('common_words.errors')"
            type="error"
            >{{ error }}</el-alert
          >
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import { Axios } from 'src/class/Axios.js';
import Formatter from 'src/class/Formatter';
import mixinMasters from 'src/util/mixinMasters';
import MixinPermissions from 'src/util/mixinPermissions';

export default {
  data() {
    return {
      model: {
        fertilizers: [],
        packages: [],
        package_values: [],
        budgeted_card_fertilizer_ids: [],
        budgeted_card_fertilizer_ids_bck: [],
      },
      fertilizer_len: 1,
      all_fertilizers: [],
      tableData1: [],
      all_fertilizers_bck: [],
      fertilizers_factors: [],
      nutrients_ids: [],
      nutrients_symbols: [],
      nutrientsColunm: [],
      nutrientsPercentages: {},
      recommendations: [],
      lot_id: null,
      num_hectares: 1,
      year_budgeted: 0,
      type_budgeted: false,
    };
  },

  computed: {
    availableFertilizers() {
      return this.all_fertilizers.filter(
        (fertilizer) => !this.model.fertilizers.includes(fertilizer.id)
      );
    },
  },

  mixins: [mixinMasters, MixinPermissions],

  methods: {
    formatNumber(value) {
      return Formatter.formatNumber(value);
    },

    calculateDifference(indexnum) {
      if (
        this.recommendations[indexnum] &&
        parseFloat(this.recommendations[indexnum]) > 0
      ) {
        return (
          this.recommendations[indexnum] -
          this.calculateTotalPercentagesColumns(indexnum)
        );
      } else {
        return this.recommendations[indexnum];
      }
    },

    calculateNutrientPercentage(index_num, indexcolumn) {
      let val =
        (((this.model.packages[index_num - 1] *
          this.fertilizers_factors[index_num - 1]) /
          this.num_hectares) *
          this.nutrientsPercentages[
            this.model.fertilizers[index_num - 1] + '-' + indexcolumn
          ]) /
        100;

      return isNaN(val) ? 0 : val;
    },

    calculateTotalPackagesColumn() {
      let val = 0;

      this.model.packages.forEach((package1) => {
        let val1 = package1 / this.num_hectares;

        if (!isNaN(val1)) {
          val += val1;
        }
      });

      return val;
    },

    calculateTotalValuesColumn() {
      let val = 0;

      this.model.packages.forEach((package1, index) => {
        let val1 =
          (package1 / this.num_hectares) * this.model.package_values[index];

        if (!isNaN(val1)) {
          //val1 = parseFloat(val1).toFixed(2)
          val += val1;
        }
      });

      return val;
    },

    calculateTotalPercentagesColumns(indexcolumn) {
      let val = 0;

      for (let i = 0; i < this.fertilizer_len; i++) {
        let val1 = this.calculateNutrientPercentage(i + 1, indexcolumn);

        if (!isNaN(val1)) {
          val += val1;
        }
      }

      return val;
    },

    validate() {
      return this.$validator
        .validateAll()
        .then((res) => {
          this.$emit('on-validated', res, this.model);
          this.$emit('fillbudgetedCardForm', 'secondStep');
          return res;
        })
        .then((resp) => {
          return this.validationInputsRequired('second-step');
        });
    },

    handleDelete(indexnum) {
      try {
        this.model.fertilizers.splice(indexnum, 1);
        let tmp = this.model.fertilizers;
        this.model.fertilizers = [];

        setTimeout(() => {
          this.model.fertilizers = tmp;
        }, 10);
      } catch (error) {}

      try {
        this.model.packages.splice(indexnum, 1);
      } catch (error) {}

      try {
        this.model.package_values.splice(indexnum, 1);
      } catch (error) {}

      try {
        this.model.budgeted_card_fertilizer_ids.splice(indexnum, 1);
      } catch (error) {}

      try {
        this.fertilizers_factors.splice(indexnum, 1);
      } catch (error) {}

      this.fertilizer_len--;
    },

    addFactor(indexnum) {
      let index = this.all_fertilizers.findIndex(
        (tableRow) => tableRow.id === this.model.fertilizers[indexnum]
      );

      if (typeof this.fertilizers_factors[indexnum] !== 'undefined') {
        this.fertilizers_factors.splice(indexnum, 1);
        this.model.package_values.splice(indexnum, 1);
      }

      this.fertilizers_factors[indexnum] =
        this.all_fertilizers[index].conversion_factor;
      this.model.package_values[indexnum] = this.all_fertilizers[index].value;
    },

    getHectares() {
      this.num_hectares = sessionStorage.getItem('hectares');
    },
  },

  created() {
    if (this.isCreate() || this.isUpdate()) {
      this.showHideLoading(true);

      Axios.getMasters('fertilization/fertilizers')
        .then((response) => {
          this.all_fertilizers = response.data.data;
          this.all_fertilizers_bck = response.data.data;

          let nutrients_ids = [];
          let nutrients_symbols = [];
          let nutrientsColunm = [];
          let nutrientsPercentages = {};

          this.all_fertilizers.forEach((fertilizer) => {
            fertilizer.fertilizer_nutrients.forEach((fertilizer_nutrient) => {
              let propname = fertilizer_nutrient.nutrient.symbol.trim();
              propname = propname.toLowerCase();

              let columnsexits = nutrientsColunm.map((colum) => {
                return colum.prop;
              });

              if (!columnsexits.includes(propname)) {
                nutrientsColunm.push({
                  label: fertilizer_nutrient.nutrient.symbol,
                  prop: propname,
                  id: fertilizer_nutrient.nutrient.id,
                });
                nutrients_ids.push(fertilizer_nutrient.nutrient.id);
                nutrients_symbols.push(fertilizer_nutrient.nutrient.symbol);
              }

              let indexNutrient = nutrientsColunm.findIndex(
                (column) => column.id === fertilizer_nutrient.nutrient_id
              );
              nutrientsPercentages[fertilizer.id + '-' + indexNutrient] =
                fertilizer_nutrient.percentage;
            });
          });

          this.nutrients_ids = nutrients_ids;
          this.nutrients_symbols = nutrients_symbols;
          this.nutrientsColunm = nutrientsColunm;
          this.nutrientsPercentages = nutrientsPercentages;

          if (this.isUpdate() && sessionStorage.getItem('editForm')) {
            let editForm = JSON.parse(sessionStorage.getItem('editForm'));

            this.fertilizer_len = 0;

            let tmp = [];
            editForm.budgeted_card_fertilizer.forEach((element) => {
              tmp.push(element.fertilizer_id);
              this.model.packages.push(element.number_packages);
              this.model.package_values.push(element.package_value);
              this.fertilizers_factors.push(
                element.fertilizer.conversion_factor
              );
              this.model.budgeted_card_fertilizer_ids.push(element.id);
              this.model.budgeted_card_fertilizer_ids_bck.push(element.id);
              this.fertilizer_len++;
            });

            this.model.id = editForm.id;

            setTimeout(() => {
              this.model.fertilizers = tmp;
              this.num_hectares = sessionStorage.getItem('hectares');
            }, 10);

            this.showHideLoading();
          } else {
            this.showHideLoading();
          }
        })
        .catch((error) => {
              this.showMessageErrors(error);
              this.showHideLoading();
            });
    } else {
      this.showHideLoading();
    }
  },
};
</script>
<style></style>
